import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';

function RoutesCount({ value, type }) {
  return (
    <div className="project-status-grid-item__routes-count-wrapper">
      <span
        data-testid="routes-count" // Added for testing
        className={cn('project-status-grid-item__routes-count', `project-status-grid-item__routes-count--${type}`, {
          'project-status-grid-item__routes-count--empty': !value,
        })}>
        {value}
      </span>
    </div>
  );
}

RoutesCount.propTypes = {
  value: PropTypes.number,
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
};

export default RoutesCount;
